import React from "react";
import { DealStatusId } from "../types";

export type FunnelItem = {
    id: string | number;
    code: string;   // code статуса
    label: string;
    color: string;
    count: number;
};

type Props = {
    funnel: FunnelItem[];
    selectedStatuses: DealStatusId[];                 // массив выбранных
    onChangeStatuses: (values: DealStatusId[]) => void;
};

export const FunnelPanel: React.FC<Props> = ({
                                                 funnel,
                                                 selectedStatuses,
                                                 onChangeStatuses,
                                             }) => {
    const isAllActive = selectedStatuses.length === 0;

    const handleToggleStatus = (code: DealStatusId) => {
        const exists = selectedStatuses.includes(code);
        if (exists) {
            // убираем статус
            onChangeStatuses(selectedStatuses.filter((s) => s !== code));
        } else {
            // добавляем статус
            onChangeStatuses([...selectedStatuses, code]);
        }
    };

    const handleAllClick = () => {
        onChangeStatuses([]); // пустой массив = все статусы
    };

    return (
        <div className="border rounded p-3">
            <div className="text-sm font-medium mb-2">Воронка</div>
            <div className="flex flex-wrap gap-2">
                {/* Кнопка "Все статусы" */}
                <button
                    type="button"
                    onClick={handleAllClick}
                    className={`flex items-center gap-2 px-2 py-1 rounded border text-left cursor-pointer transition
            ${
                        isAllActive
                            ? "border-blue-500 bg-blue-50"
                            : "border-gray-200 hover:bg-gray-50"
                    }`}
                >
                    <span className="text-sm font-medium">Все статусы</span>
                </button>

                {funnel.map((f) => {
                    const isActive = selectedStatuses.includes(f.code as DealStatusId);

                    return (
                        <button
                            key={f.id}
                            type="button"
                            onClick={() => handleToggleStatus(f.code as DealStatusId)}
                            className={`flex items-center gap-2 px-2 py-1 rounded border text-left cursor-pointer transition
                ${
                                isActive
                                    ? "border-blue-500 bg-blue-50"
                                    : "border-gray-200 hover:bg-gray-50"
                            }`}
                        >
              <span
                  className="w-2 h-2 rounded-full"
                  style={{ background: f.color }}
              />
                            <span className="text-sm">{f.label}:</span>
                            <span className="text-sm font-semibold">{f.count}</span>
                        </button>
                    );
                })}
            </div>
        </div>
    );
};
